import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Map from '../../../map/components/Map';
import useStyles from './MissionMap.styles';
import { RouteExact } from '../../models/Route';
import { WorkzoneExact } from '../../models/Workzone';
import { MapGeometryExact } from '../../../map/models/MapGeometry';
import { JurisdictionExact } from '../../models/Jurisdiction';
import { ObstacleExact } from '../../models/Obstacle';
import { UrbanAreaExact } from '../../models/UrbanArea';
import { AirportExact } from '../../models/Airport';
import Route from '../../../map/components/route/Route';
import { getBounds } from '../../../map/formatters/mapFormatter';
import Workzone from '../../../map/components/workzone/Workzone';
import UrbanArea from '../../../map/components/urbanArea/UrbanArea';
import Jurisdiction from '../../../map/components/jurisdiction/Jurisdiction';
import Obstacle from '../../../map/components/obstacle/Obstacle';
import Airport from '../../../map/components/airport/Airport';
import PipelineCenterline from '../../../map/components/pipelineCenterline/PipelineCenterline';
import { PipelineCenterlineExact } from '../../models/PipelineCenterline';

const getInitialBounds = (jurisdictions) => {
  const flattenedCoordinates = jurisdictions.reduce((coordinates, { geometry }) => [...coordinates, ...geometry.coordinates], []);
  return getBounds(flattenedCoordinates);
};
const defaultZoom = [11];
const MissionMap = ({ routes, workzones, urbanAreas, jurisdictions, obstacles, airports, pipelineCenterlines, centeredGeometries }) => {
  const classes = useStyles();

  const [bounds, setBounds] = useState(getInitialBounds(routes));

  useEffect(() => {
    if (centeredGeometries) {
      const flattenedCoordinates = centeredGeometries.reduce((coordinates, geometry) => [...coordinates, ...geometry.coordinates], []);
      setBounds(getBounds(flattenedCoordinates));
    }
  }, [centeredGeometries]);

  return (
    <div className={classes.root}>
      <Map initialBounds={bounds} zoom={defaultZoom}>
        <>
          {routes.map(({ geometry, visible }, index) => (
            <Route key={String(index)} index={index} coordinatesArray={geometry.coordinates} visible={visible} />
          ))}
          {workzones.map(({ geometry, visible }, index) => (
            <Workzone key={String(index)} index={index} coordinatesArray={geometry.coordinates} visible={visible} />
          ))}
          {urbanAreas.map(({ geometry, visible }, index) => (
            <UrbanArea key={String(index)} index={index} coordinatesArray={geometry.coordinates} visible={visible} />
          ))}
          {jurisdictions.map(({ geometry, visible }, index) => (
            <Jurisdiction key={String(index)} index={index} coordinatesArray={geometry.coordinates} visible={visible} />
          ))}
          {obstacles.map(({ geometry, visible }, index) => (
            <Obstacle key={String(index)} coordinate={geometry.coordinates[0]} visible={visible} />
          ))}
          {airports.map(({ geometry, visible }, index) => (
            <Airport key={String(index)} coordinate={geometry.coordinates[0]} visible={visible} />
          ))}
          {pipelineCenterlines.map(({ geometry, visible }, index) => (
            <PipelineCenterline key={String(index)} index={index} coordinatesArray={geometry.coordinates} visible={visible} />
          ))}
        </>
      </Map>
    </div>
  );
};

MissionMap.propTypes = {
  jurisdictions: PropTypes.arrayOf(JurisdictionExact),
  routes: PropTypes.arrayOf(RouteExact).isRequired,
  workzones: PropTypes.arrayOf(WorkzoneExact),
  urbanAreas: PropTypes.arrayOf(UrbanAreaExact),
  obstacles: PropTypes.arrayOf(ObstacleExact),
  airports: PropTypes.arrayOf(AirportExact),
  pipelineCenterlines: PropTypes.arrayOf(PipelineCenterlineExact),
  centeredGeometries: PropTypes.arrayOf(MapGeometryExact),
};

MissionMap.defaultProps = {
  jurisdictions: [],
  workzones: [],
  urbanAreas: [],
  obstacles: [],
  airports: [],
  pipelineCenterlines: [],
  centeredGeometries: undefined,
};

MissionMap.defaultProps = {};

export default MissionMap;
